export default "__VITE_ASSET__DKTKcdIb__"